import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconHorizonBlueSizeS from './IconHorizonBlue_size_s';

const props: CreateIconArguments = {
  l: IconHorizonBlueSizeS,
  m: IconHorizonBlueSizeS,
  s: IconHorizonBlueSizeS,
  xs: IconHorizonBlueSizeS,
  name: 'IconHorizonBlue',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
